import styled, { css } from 'styled-components';

import { captionRegular } from 'styles/mixins/fonts';
import { DeleteButtonWithRef } from 'components/specified-buttons';

// POS Deals (26 Oct 2026): a deal's lines, grouped under one caption.
export const Group = styled.div`
  gap: 12px;
  display: flex;
  padding: 12px;
  border-radius: 16px;
  flex-direction: column;
  ${({ theme }) => css`
    border: 1px solid ${theme.config.sidebar.border};
  `}
`;

export const Total = styled.p`
  ${captionRegular};
`;

export const StyledRemoveButton = styled(DeleteButtonWithRef)`
  flex-shrink: 0;
`;
